import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { setDocumentTitle } from "@/lib/documentTitle";

import { table_name } from "./config";
import { BankPositionsEdit } from "./edit";
import { BankPositionsNew } from "./new";
import { BankPositionsTable } from "./table";

export default function C3BankPositions() {
  const { t } = useTranslation("tables");

  useEffect(() => {
    setDocumentTitle(
      `Quantilia | ${t(`${table_name}.title`, {
        defaultValue: "Bank Positions",
      })}`,
    );
  }, [t]);

  return (
    <Routes>
      <Route path=":id" element={<BankPositionsEdit />} />
      <Route index element={<BankPositionsTable />} />
      <Route path="new" element={<BankPositionsNew />} />
    </Routes>
  );
}
